import { render, staticRenderFns } from "./EditTourInfoPreviewBox.vue?vue&type=template&id=7b00d35a&scoped=true&"
import script from "./EditTourInfoPreviewBox.vue?vue&type=script&lang=js&"
export * from "./EditTourInfoPreviewBox.vue?vue&type=script&lang=js&"
import style0 from "./EditTourInfoPreviewBox.vue?vue&type=style&index=0&id=7b00d35a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b00d35a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VIcon,VSpacer})
